<!-- 游玩攻略 -->
<template>
  <div class="frame">
    <div class="banner">
      <div class="bg"></div>
    </div>
    <div class="wrap">
      <div class="contain">
        <div class="title-box">
          <div class="title">{{ $t("strategy.title") }}</div>
          <div class="en">{{ $t("strategy.en") }}</div>
          <div class="line"></div>
        </div>
        <div class="list">
          <router-link
            :to="'/strategyDetail?id=' + item.id"
            :class="{ item: true, first: idx < 3 }"
            v-for="(item, idx) in strategy"
            :key="item.id"
          >
            <img
              :src="item.post"
              :alt="item.title"
              class="post"
              v-show="idx < 3"
            />
            <div class="text">
              <div class="title">{{ item.title }}</div>
              <div class="desc">{{ item.intro }}</div>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getStrategyList } from "../utils/localeContent";

export default {
  data() {
    return {
      strategy: [],
    };
  },
  watch: {
    "$i18n.locale"() {
      this.loadStrategy();
    },
  },
  created() {
    this.loadStrategy();
  },
  methods: {
    loadStrategy() {
      this.strategy = getStrategyList(this.$i18n.locale);
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  height: 80vh;

  .bg {
    width: 100%;
    height: 100%;
    background-image: url("../assets/source/strategy_banner.jpg");
    background-size: cover;
    background-position-x: center;
    background-attachment: fixed;
  }
}

.wrap {
  padding: 90px 0;
  background-image: url(https://26823097.s61i.faiusr.com/2/AD0IuZPlDBACGAAgy8P2ggYolsL_gwYwgA842go.jpg);
  background-size: cover;
  background-position: center center;

  .contain {
    width: 1200px;
    margin: 0 auto;
  }
  .title-box {
    position: relative;
    color: #fff;
    text-align: center;

    .title {
      font-size: 34px;
      position: relative;
      z-index: 2;
    }
    .en {
      font-size: 40px;
      font-weight: bolder;
      letter-spacing: 3px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0.5),
        transparent
      );
      -webkit-background-clip: text;
      background-clip: text;
      -webkit-text-fill-color: transparent;
      position: absolute;
      left: 50%;
      top: -40%;
      transform: translateX(-50%);
      z-index: 1;
    }
    .line {
      width: 40px;
      height: 3px;
      margin: 20px auto 30px;
      background-color: $theme;
    }
  }
  .list {
    margin-top: 50px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .item {
      width: 100%;
      margin-top: 20px;
      border-bottom: 1px dashed #4d4e59;
      cursor: pointer;
      text-decoration: none;

      &:hover {
        .title {
          color: $theme;
        }
      }

      .post {
        width: 365px;
        height: 210px;
        object-fit: cover;
      }
      .text {
        padding: 10px;
        box-sizing: border-box;
        color: #fff;

        .title {
          font-size: 15px;
        }
        .desc {
          margin-top: 10px;
          color: #8f919d;
          font-size: 12px;
          line-height: 26px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      }
    }
    .first {
      width: 365px;
      margin-top: 0;
      transition: 0.5s;

      &:hover {
        transform: translateY(-20px);
      }
    }
  }
}
</style>
